import { create } from 'zustand';

interface UIState {
  reset: () => void;
  // Sidebar state
  isSidebarOpen: boolean;
  activeSessionId: string | null;

  // Code modal
  openModalCode: string | null;

  // Loading states
  isLoading: boolean;

  // Modal states
  isCreateSessionModalOpen: boolean;
  isDeleteSessionModalOpen: boolean;

  // Actions
  setIsSidebarOpen: (isOpen: boolean) => void;
  setOpenModalCode: (openModalCode: string | null) => void;
  setActiveSessionId: (sessionId: string | null) => void;
  setIsLoading: (isLoading: boolean) => void;
  setIsCreateSessionModalOpen: (isOpen: boolean) => void;
  setIsDeleteSessionModalOpen: (isOpen: boolean) => void;
}

const defaultState = {
  isSidebarOpen: true,
  activeSessionId: null,
  openModalCode: '',
  isLoading: false,
  isCreateSessionModalOpen: false,
  isDeleteSessionModalOpen: false,
};

export const useUIStore = create<UIState>((set) => ({
  // Initial state
  ...defaultState,

  // Actions
  setIsSidebarOpen: (isOpen) => set({ isSidebarOpen: isOpen }),
  setActiveSessionId: (sessionId) => set({ activeSessionId: sessionId }),
  setIsLoading: (isLoading) => set({ isLoading }),
  setOpenModalCode: (openModalCode) => set({ openModalCode }),
  setIsCreateSessionModalOpen: (isOpen) => set({ isCreateSessionModalOpen: isOpen }),
  setIsDeleteSessionModalOpen: (isOpen) => set({ isDeleteSessionModalOpen: isOpen }),

  reset: () => set({ ...defaultState }),
}));